/**
 * Where a support link lands.
 *
 * The console cannot set a cookie on a class's own address, so it hands over a one-time
 * link. This page spends it, once, and then goes to the editor — as the student, with
 * their permission, and unable to change anything.
 */

import { Spinner } from '@praxadon/ui';
import { useEffect, useState } from 'react';

import { describeError } from '../../api/client.ts';
import { support } from '../../api/endpoints.ts';

export function SupportClaim() {
  const ticket = new URLSearchParams(window.location.search).get('ticket');
  const [problem, setProblem] = useState<string | null>(ticket ? null : 'That link is incomplete.');

  useEffect(() => {
    if (!ticket) return;
    support.claim(ticket).then(
      () => {
        // Replace, so the ticket does not stay in the history of this window.
        window.location.replace('/');
      },
      (error: unknown) => {
        setProblem(describeError(error));
      },
    );
  }, [ticket]);

  return (
    <main className="grid min-h-dvh place-items-center bg-surface-sunken p-6">
      <div className="max-w-sm text-center">
        {problem ? (
          <>
            <h1 className="text-lg font-semibold text-fg">This support link cannot be used</h1>
            <p className="mt-2 text-sm text-fg-muted">{problem}</p>
          </>
        ) : (
          <Spinner size={20} label="Opening the support session" />
        )}
      </div>
    </main>
  );
}
